function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "store");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Calendar---Events-Calendar",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "1.-Calendar---show-deleted-events",
  transform: "translate(-1051.000000, -542.000000)",
  fill: "#5B6C7A",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "events",
  transform: "translate(359.000000, 247.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-5",
  transform: "translate(0.000000, 75.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "10-12-PM",
  transform: "translate(15.000000, 141.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "8.-Large-Components/8.5-Calendar-Card-Copy-19",
  transform: "translate(523.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "4.-Icons/Calendar/12px/Dark",
  transform: "translate(149.432692, 76.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.6866846,9.49767614 C17.7968452,9.49767614 17.9023137,9.4906266 18.0077822,9.47657328 C19.4796491,9.2796896 20.1780803,7.53595749 19.3905914,6.27969675 L17.8694921,3.8515867 C17.7335595,3.63362304 17.4921584,3.50002503 17.2343465,3.50002503 L7.76561908,3.50002503 C7.50780719,3.50002503 7.26640609,3.63362304 7.1304735,3.8515867 L5.60937422,6.27969675 C4.82421984,7.53360001 5.52031651,9.27735501 6.98749135,9.47657328 C7.09295985,9.4906266 7.20078583,9.49767614 7.30858892,9.49767614 C8.00232811,9.49767614 8.61639372,9.19298937 9.03826771,8.72188301 C9.46014171,9.19298937 10.0765419,9.49767614 10.7679465,9.49767614 C11.4617086,9.49767614 12.0757742,9.19298937 12.4976482,8.72188301 C12.9195222,9.19298937 13.5359224,9.49767614 14.227327,9.49767614 C14.9210662,9.49767614 15.5351318,9.19298937 15.9570058,8.72188301 C16.3812144,9.19298937 16.99528,9.49767614 17.6866846,9.49767614 Z M17.7523049,15.4999964 C18.1671522,15.4999964 18.5023031,15.1648456 18.5023031,14.7499982 L18.5023031,10.1375138 C18.3757546,10.1750045 18.2491833,10.2054686 18.1179427,10.2218794 C17.9749606,10.2406248 17.8343359,10.2500089 17.6913767,10.2500089 C17.4570022,10.2500089 17.2249624,10.2148528 16.9999721,10.1609512 L16.9999721,12.5000036 L7.99999352,12.5000036 L7.99999352,10.1609512 C7.77500321,10.2125182 7.54296336,10.2500089 7.30858892,10.2500089 C7.16796425,10.2500089 7.025005,10.2406248 6.88671492,10.2218794 C6.75547439,10.2031341 6.62656845,10.17267 6.50233168,10.1375138 L6.50233168,14.7499982 C6.50233168,15.1648456 6.83750544,15.4999964 7.2523299,15.4999964 L17.7523049,15.4999964 Z",
  id: "store"
}))))))));

var SvgStoreEventIcon = function SvgStoreEventIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "13px",
    viewBox: "0 0 16 13",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStoreEventIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/StoreEventIcon.7bb77114.svg";
export { ForwardRef as ReactComponent };